export const tododata =[
    "Weekly Bigbazar Shopping",
    "Go Outside Picnic on Sunday",
    "Write a blog post",
    "Do the chicken dance",
    "Pay the electricity bills",
    "Make dinner reservation",
    "Meeting with photographer",
    "Birthday wish to best friend"
]